import React, { Component } from "react";
import ProductList from "../components/ProductList";

class ProductListContainer extends Component {
  state = {
    filterText: "",
    products: []
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.products !== nextProps.products) {
      const isPreview = window.location.href.indexOf("preview") >= 0;
      if (isPreview) {
        this.setState({
          products: [...nextProps.products],
          filterText: ""
        });
      } else {
        let products = [
          { id: 1, title: "New Product", description: "" },
          ...nextProps.products
        ];
        this.setState({
          products,
          filterText: ""
        });
      }
    }
  }

  render() {
    const { status, products } = this.props;
    return (
      <ProductList
        refresh={this.props.refresh}
        onProductChange={this.props.onProductChange}
        status={status}
        selected={this.props.selected}
        products={this.state.products}
        filterText={this.state.filterText}
      />
    );
  }
}

export default ProductListContainer;



// WEBPACK FOOTER //
// ./src/containers/ProductList.js